export default __webpack_public_path__ + "static/media/logo-inQba-admin.95426cc2.svg";